import { configureStore } from "@reduxjs/toolkit";
import globalRecuder from "./slices/global";
import modalPricingReducer from "./slices/modalPricing";
import { api } from "../services/api";

export const store = configureStore({
  reducer: {
    global: globalRecuder,
    modalPricing: modalPricingReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

// Types for use in components
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
